import { Text } from 'components/Text';
import { React } from 'libs/react';
import { Icon } from 'components/Icon';
import { useUser } from 'components/user/UserProvider';
import './DealActivityStreamItem.scss';
/**
 * @component DealActivityStreamItem
 * @since 1.0.0
 */
export function DealActivityStreamItem(props) {
    const { item, deal } = props;
    const user = useUser();
    /**
     * Public quote updates have no authenticated user, so `user` is null.
     * Match EntityHistory, which labels those events as Public.
     */
    const actorName = (historyItem) => { var _a; return ((_a = historyItem.user) === null || _a === void 0 ? void 0 : _a.fullname) || t('Public'); };
    /**
     * @function getIcon
     * @since 1.0.0
     * @hidden
     */
    const getIcon = (value) => {
        var _a, _b, _c, _d, _e, _f;
        switch (value) {
            case 'CREATED':
                return React.createElement(Icon, { value: "check" });
            case 'UPDATED':
            case 'ASSIGNED':
                return React.createElement(Icon, { value: "user" });
            case 'ACCEPTED':
                return React.createElement(Icon, { value: "check" });
            case 'DISCOUNT_APPLIED':
                return React.createElement(Icon, { value: "bell" });
            case 'commentContact':
                return React.createElement(Text, { value: (_a = deal === null || deal === void 0 ? void 0 : deal.contact) === null || _a === void 0 ? void 0 : _a.fullname.charAt(0) });
            case 'commentRep':
                return ((_c = (_b = user.user) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.url) ? (React.createElement("img", { src: (_e = (_d = user.user) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.url })) : (React.createElement(Text, { value: (_f = item.user) === null || _f === void 0 ? void 0 : _f.fullname.charAt(0) }));
        }
    };
    /**
     * @function contentList
     * @since 1.0.0
     * @hidden
     */
    const contentList = (item) => {
        var _a, _b;
        if (item.__typename === 'EntityHistory') {
            switch (item.event) {
                case 'CREATED':
                    return (React.createElement("div", { className: "deal-activity-stream-item-container" },
                        React.createElement("div", { className: "deal-activity-stream-item-container-icon-line" },
                            React.createElement("div", { className: "deal-activity-stream-item-container-icon" }, getIcon(item.event)),
                            React.createElement("div", { className: "deal-activity-stream-item-container-line" })),
                        React.createElement("div", { className: "deal-activity-stream-item-container-text" },
                            React.createElement(Text, { value: actorName(item) + t(' has created the quote.') }),
                            React.createElement(Text, { value: item.createdAt }))));
                case 'DISCOUNT_APPLIED':
                    return (React.createElement("div", { className: "deal-activity-stream-item-container" },
                        React.createElement("div", { className: "deal-activity-stream-item-container-icon-line" },
                            React.createElement("div", { className: "deal-activity-stream-item-container-icon" }, getIcon(item.event)),
                            React.createElement("div", { className: "deal-activity-stream-item-container-line" })),
                        React.createElement("div", { className: "deal-activity-stream-item-container-text" },
                            React.createElement(Text, { value: actorName(item) + t(' has applied a discount to the quote.') }),
                            React.createElement(Text, { value: item.createdAt }))));
                case 'UPDATED':
                    return (React.createElement("div", { className: "deal-activity-stream-item-container" },
                        React.createElement("div", { className: "deal-activity-stream-item-container-icon-line" },
                            React.createElement("div", { className: "deal-activity-stream-item-container-icon" }, getIcon(item.event)),
                            React.createElement("div", { className: "deal-activity-stream-item-container-line" })),
                        React.createElement("div", { className: "deal-activity-stream-item-container-text" },
                            React.createElement(Text, { value: ((_a = item.user) === null || _a === void 0 ? void 0 : _a.fullname)
                                    ? item.user.fullname + t(' has updated the quote.')
                                    : t('Client has updated the quote.') }),
                            React.createElement(Text, { value: item.createdAt }))));
                case 'ASSIGNED':
                    return (React.createElement("div", { className: "deal-activity-stream-item-container" },
                        React.createElement("div", { className: "deal-activity-stream-item-container-icon-line" },
                            React.createElement("div", { className: "deal-activity-stream-item-container-icon" }, getIcon(item.event)),
                            React.createElement("div", { className: "deal-activity-stream-item-container-line" })),
                        React.createElement("div", { className: "deal-activity-stream-item-container-text" },
                            React.createElement(Text, { value: t('Quote reassigned') }),
                            React.createElement(Text, { value: item.createdAt }))));
                case 'ACCEPTED':
                    return (React.createElement("div", { className: "deal-activity-stream-item-container" },
                        React.createElement("div", { className: "deal-activity-stream-item-container-icon-line" },
                            React.createElement("div", { className: "deal-activity-stream-item-container-icon" }, getIcon(item.event)),
                            React.createElement("div", { className: "deal-activity-stream-item-container-line" })),
                        React.createElement("div", { className: "deal-activity-stream-item-container-text" },
                            React.createElement(Text, { value: t('Client has accepted the quote.') }),
                            React.createElement(Text, { value: item.createdAt }))));
            }
        }
        else if (item.__typename === 'DealMessage') {
            if (item.user) {
                return (React.createElement("div", { className: "deal-activity-stream-item-container" },
                    React.createElement("div", { className: "deal-activity-stream-item-container-icon-line" },
                        React.createElement("div", { className: "deal-activity-stream-item-container-icon" }, getIcon('commentRep')),
                        React.createElement("div", { className: "deal-activity-stream-item-container-line" })),
                    React.createElement("div", { className: "deal-activity-stream-item-container-text message-rep" },
                        React.createElement("div", { className: "deal-activity-stream-item-container-message-person message-rep" },
                            React.createElement(Text, { value: `${item.user.firstname} ${item.user.lastname}` }),
                            React.createElement(Text, { value: item === null || item === void 0 ? void 0 : item.createdAt })),
                        React.createElement("div", null,
                            React.createElement(Text, { value: item === null || item === void 0 ? void 0 : item.message })))));
            }
            else {
                return (React.createElement("div", { className: "deal-activity-stream-item-container" },
                    React.createElement("div", { className: "deal-activity-stream-item-container-icon-line" },
                        React.createElement("div", { className: "deal-activity-stream-item-container-icon" }, getIcon('commentContact')),
                        React.createElement("div", { className: "deal-activity-stream-item-container-line" })),
                    React.createElement("div", { className: "deal-activity-stream-item-container-text message-contact" },
                        React.createElement("div", { className: "deal-activity-stream-item-container-message-person message-contact" },
                            React.createElement(Text, { value: (_b = deal === null || deal === void 0 ? void 0 : deal.contact) === null || _b === void 0 ? void 0 : _b.fullname }),
                            React.createElement(Text, { value: item === null || item === void 0 ? void 0 : item.createdAt })),
                        React.createElement("div", null,
                            React.createElement(Text, { value: item === null || item === void 0 ? void 0 : item.message })))));
            }
        }
    };
    return React.createElement("div", { className: "deal-activity-stream-item" }, contentList(item));
}
